<template>
  <div>
    <LoadingWidget v-if="loading" class="py-16" />

    <transition name="fade">
      <section v-if="!loading" class="py-8 py-md-12 py-lg-16 section-template">
        <v-container>
          <TitleWidget
            v-if="title"
            :title="title"
            :subtitle="subtitle"
            class="primary--text justify-center text-center"
          />

          <template>
            <slot />
          </template>
        </v-container>
      </section>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  props: {
    title: String,
    subtitle: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
  },
};
</script>
